import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // A 401 is handled by the api layer (it redirects); a 404 will not fix itself.
      retry: (count, error) =>
        error instanceof ApiError && [401, 403, 404, 422].includes(error.status)
          ? false
          : count < 2,
    },
  },
});
